import { CountUp } from 'countup.js';

(() => {
  const options = {
    useGrouping: true,
    separator: ',',
    enableScrollSpy: true,
  };

  const counterLocations = document?.getElementById('counterLocations');
  const counterLocationsNumber = counterLocations?.textContent;
  if (!counterLocations) return;
  const countUp = new CountUp(counterLocations, counterLocationsNumber, options);
  if (!countUp.error) {
    countUp.start();
  } else {
    console.error(countUp.error);
  }

  const counterOwners = document?.getElementById('counterOwners');
  const counterOwnersNumber = counterOwners?.textContent;
  const countUpOwners = new CountUp(counterOwners, counterOwnersNumber, options);
  if (!countUpOwners.error) {
    countUpOwners.start();
  } else {
    console.error(countUpOwners.error);
  }

  const counterProducts = document?.getElementById('counterProducts');
  const counterProductsNumber = counterProducts?.textContent;
  const countUpProducts = new CountUp(counterProducts, counterProductsNumber, options);
  if (!countUpProducts.error) {
    countUpProducts.start();
  } else {
    console.error(countUpProducts.error);
  }
})();
